/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Field_Case_NumberInputs */

const en_case_field_case_number = /** @type {(inputs: Case_Field_Case_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case number`)
};

const pt_br2_case_field_case_number = /** @type {(inputs: Case_Field_Case_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número do caso`)
};

/**
* | output |
* | --- |
* | "Case number" |
*
* @param {Case_Field_Case_NumberInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_field_case_number = /** @type {((inputs?: Case_Field_Case_NumberInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Field_Case_NumberInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_field_case_number(inputs)
	return pt_br2_case_field_case_number(inputs)
});